import script from "./OfUpgradeSessionForm.vue?vue&type=script&setup=true&lang=js"
export * from "./OfUpgradeSessionForm.vue?vue&type=script&setup=true&lang=js"

import "./OfUpgradeSessionForm.vue?vue&type=style&index=0&id=be7d8e06&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be7d8e06"]])

export default __exports__